import { type Static, Type } from "@sinclair/typebox";

const CanonicalReasonSchema = Type.String({
  minLength: 2,
  maxLength: 500,
  pattern: "^\\S(?:[\\s\\S]*\\S)?$",
});
const CashShiftDecisionFields = {
  cashShiftId: Type.String({ minLength: 1, maxLength: 128 }),
  cashShiftVersion: Type.Integer({ minimum: 1, maximum: Number.MAX_SAFE_INTEGER }),
  cashShiftBusinessDate: Type.String({ pattern: "^[0-9]{4}-[0-9]{2}-[0-9]{2}$" }),
  workforceProjectionRevision: Type.Integer({
    minimum: 1,
    maximum: Number.MAX_SAFE_INTEGER,
  }),
  workforceProjectionContentSha256: Type.String({ pattern: "^[0-9a-f]{64}$" }),
};

export const GroupBuyOnlineOperatorModeSchema = Type.Union([
  Type.Literal("CASHIER_CONFIRMATION"),
  Type.Literal("MANAGER_TAKEOVER"),
]);
export type GroupBuyOnlineOperatorMode = Static<typeof GroupBuyOnlineOperatorModeSchema>;

export const GroupBuyOnlineOperatorDecisionSchema = Type.Union([
  Type.Object(
    {
      mode: Type.Literal("CASHIER_CONFIRMATION"),
      reason: Type.Null(),
      ...CashShiftDecisionFields,
      availableCashierCount: Type.Integer({ minimum: 1, maximum: 10_000 }),
    },
    { additionalProperties: false },
  ),
  Type.Object(
    {
      mode: Type.Literal("MANAGER_TAKEOVER"),
      reason: CanonicalReasonSchema,
      ...CashShiftDecisionFields,
      availableCashierCount: Type.Literal(0),
    },
    { additionalProperties: false },
  ),
]);
export type GroupBuyOnlineOperatorDecision = Static<typeof GroupBuyOnlineOperatorDecisionSchema>;

export const GroupBuyManualOperatorModeSchema = Type.Union([
  Type.Literal("CASHIER_RECORD"),
  Type.Literal("MANAGER_RECORD"),
  Type.Literal("OWNER_EXCEPTION"),
]);
export type GroupBuyManualOperatorMode = Static<typeof GroupBuyManualOperatorModeSchema>;

export const GroupBuyManualOperatorDecisionSchema = Type.Union([
  Type.Object(
    {
      mode: Type.Union([Type.Literal("CASHIER_RECORD"), Type.Literal("MANAGER_RECORD")]),
      reason: Type.Null(),
      ...CashShiftDecisionFields,
      availableCashierCount: Type.Integer({ minimum: 0, maximum: 10_000 }),
    },
    { additionalProperties: false },
  ),
  Type.Object(
    {
      mode: Type.Literal("OWNER_EXCEPTION"),
      reason: CanonicalReasonSchema,
      ...CashShiftDecisionFields,
      availableCashierCount: Type.Integer({ minimum: 0, maximum: 10_000 }),
    },
    { additionalProperties: false },
  ),
]);
export type GroupBuyManualOperatorDecision = Static<typeof GroupBuyManualOperatorDecisionSchema>;

export const GroupBuyOperatorDecisionSchema = Type.Union([
  GroupBuyOnlineOperatorDecisionSchema,
  GroupBuyManualOperatorDecisionSchema,
]);
export type GroupBuyOperatorDecision = Static<typeof GroupBuyOperatorDecisionSchema>;
